import initMap from './init-map';

$(function() {
    initMap.initMap();
});





// WEBPACK FOOTER //
// ./resources/assets/js/components/category/map.js